import { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { unregister } from 'utils/serviceWorker'

import addPolyfills from 'polyfills'

const originalDefine = customElements.define
customElements.define = function (name, constructor, options) {
  if (!customElements.get(name)) {
    originalDefine.call(this, name, constructor, options)
  }
}

const App = lazy(() => import('./App'))

function runApp() {
  addPolyfills().then(render)
}

function render() {
  const container = document.getElementById('root')
  const root = createRoot(container) //
  root.render(
    <Suspense fallback={<div />}>
      <App />
    </Suspense>,
  )
}

runApp()

unregister()
